/**
 * Really just a wrapper for the plugin (el of the view) -- ajax events captured at the doc level.
 * As of jQuery 1.8, the .ajaxStart() method should only be attached to document.
 * Move up (doc level) and mediate  ?
 */

var SpinView = require('../../../common/spinView'),
    $ = require('jquery');


module.exports = SpinView.extend({

    startHidden: true,

    settings: _.extend( {}, SpinView.prototype.settings, {
        color: '#FFF',
        length: 3,
        radius: 3,
        width: 2
    }),

    onAfterRender: function() {
        var $doc = $(document),
            suppressSpinner = function(url) {
                return url.indexOf('/rest/v2/api/cre') > -1 || url.indexOf('keepAlive') > -1; //separate loading indicators for the pages (images)
            },
            self = this;

        // Use send/complete to filter action based off ajax options url
        $doc.ajaxSend(function (e, jqXHR, ajaxOptions) {

            if (suppressSpinner(ajaxOptions.url))
                return;

            self.triggerMethod('start');

        }).ajaxComplete(function (e, jqXHR, ajaxOptions) {

            if (suppressSpinner(ajaxOptions.url))
                return;

            self.triggerMethod('stop');

        });

    },

    onBeforeDestroy: function () {

        SpinView.prototype.onBeforeDestroy.apply(this, arguments);

        //(jQ source indicates these fn's translate into events -- eg: $.fn.ajaxSend = function ( handler ) { return this.on('ajaxSend', handler); };
        $(document).off('ajaxSend ajaxComplete');
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/headerRight/ajaxIndicator.js
 ** module id = 737
 ** module chunks = 0
 **/